import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ShipmentRoutesService} from '../services/shipment-routes.service';
import {ShipmentRoute} from '../services/shipment-route';

declare let NProgress: any;

@Component({
    selector: 'app-shipment-routes',
    templateUrl: './shipment-routes.component.html',
    styleUrls: ['./shipment-routes.component.scss'],
    providers: [ShipmentRoutesService]
})

export class ShipmentRoutesComponent implements OnInit {

    shipmentRoutes: ShipmentRoute[];

    currentPage = 1;
    perPage = 20;
    total: number;

    constructor(public shipmentRoutesService: ShipmentRoutesService, private router: Router
    ) {
    }

    ngOnInit() {
        this.shipmentRoutesService.getShipmentRoutes().then(shipmentRoutes => {
            this.shipmentRoutes = shipmentRoutes;
        });
    }

    add() {
        this.router.navigateByUrl('/shipment-routes/new');
        //   const bundle = ShipmentRoute.fromJSON({});
        //   bundle.branch = null;
        //   bundle.name = 'New Route';
//
        //   this.shipmentRoutesService.addShipmentRoute(bundle).then((shipmentRoute) => {
        //   });
    }

    delete(shipmentRoute: ShipmentRoute) {
    }

}
